import React, { useEffect, useState } from "react";
import Section_title from "../../../common-components/section-title/Section_title";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
} from "../../../../features/admin/master/country/Slice";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import Add from "./Add";
import Pagination_Holder from "../../../common-components/Pagination_Holder/Pagination_Holder";
import Table_search from "../../../common-components/table-search/Table_search";
import Delete_Modal from "../../../common-components/common_Modal/Delete_Modal/Delete_Modal";
import Delete_Confirm_Modal from "../../../common-components/common_Modal/Delete_Confirm_Modal/Delete_Confirm_Modal";
import {
  getAllCitiesWithoutType,
  getAllVehicleCatWithoutType,
} from "../../../../features/admin/common/Slice";
import Confirm_Status_Change from "../../../common-components/common_Modal/Confirm_Status_Change/Confirm_Status_Change";
const Country = () => {
  const dispatch = useDispatch();

  const Permission = useSelector((state) => state.auth?.admin_info);

  const {
    recharge,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
    modalMessage,
    modalShow,
    setModalShow,
    vehicleType,
    setVehicleType,
  } = IndexUse();

  const vehicleCategory = useSelector(
    (state) => state.common.all_vehicle_category,
  );

  const vehicleList = useSelector(
    (state) => state.common.all_vehicle_category_without_type,
  );

  const [add, setAdd] = useState(false);
  const [edit, setEdit] = useState(false);
  const [rdelete, setRDelete] = useState(false);
  const [showError, setShowError] = useState("");
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);

  const [id, setId] = useState("");

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const handleDeleteModal = async (id) => {
    await setDeleteConfirmModal(id);
  };

  const handleDelete = async (id) => {
    await setDeleteConfirmModal(false);
    const success = await deleteData(id);
    setRDelete(false);
    if (success) setSuccess(true);
    else setErr(true);
  };

  const handleStatusChange = async (id) => {
    const success = await toggleStatus(id);

    if (success) {
      await fetch();
      setRDelete(false);
      setStatusConfirmModal(false);
    } else {
      setErr(true);
    }
  };

  const [statusConfirmModal, setStatusConfirmModal] = useState(false);
  const handleStatusModal = async (id) => {
    await setStatusConfirmModal(id);
  };

  useEffect(() => {
    dispatch(getAllVehicleCatWithoutType());
    dispatch(getAllCitiesWithoutType());
  }, [dispatch]);

  return (
    <section className="content_body section_box">
      <div className="top_title_sec">
        <div className="forms_section">
          <div className="row align-items-end">
            <div className="col-md-12">
              <Section_title title="Recharge" alltotal="" />
            </div>
            {/* <div className="col-md-5 mb-3 ps-0">
            <Table_search name={name} setName={setName} fetch={fetch} />
          </div> */}
            <div className="col-md-4 mb-3 form-group">
              <div className="form-group">
                <label className="form-label">Filter by Vehicle Category</label>
                <Select
                  name="vehicle_category_id"
                  value={vehicleType}
                  options={vehicleList}
                  placeholder={"Vehicle Category"}
                  onInputChange={() => {
                    dispatch(getAllVehicleCatWithoutType());
                  }}
                  onChange={(val) => {
                    setVehicleType(val);
                    fetch();
                  }}
                />
              </div>
            </div>
            <div className="col-md-4 mb-3" style={{ width: "fit-content" }}>
              <button
                className="btn btn-danger "
                onClick={() => {
                  setVehicleType("");
                }}
              >
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>

      {Permission.includes(IDS.Permission.Recharge.Add) && (
        <Add
          id={id}
          setId={setId}
          setSuccess={setSuccess}
          setErr={setErr}
          showError={showError}
          setShowError={setShowError}
        />
      )}

      <div className="table_section theme_bg">
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>S. no.</th>
                <th>Price</th>
                <th>Vehicle Category</th>
                <th>District</th>
                <th>Discount Percent</th>
                <th>Tax Percent</th>
                <th>Bookings Amount / Publish Counts For Share Taxi</th>
                <th>Description</th>

                {Permission.includes(IDS.Permission.Recharge.Edit) && (
                  <>
                    <th>Status </th>
                  </>
                )}

                {Permission.includes(IDS.Permission.Recharge.Delete) && (
                  <th>Action</th>
                )}
              </tr>
            </thead>
            <tbody>
              {recharge?.data?.data?.length > 0 ? (
                recharge?.data.data?.map((val, index) => (
                  <tr key={index}>
                    <td>
                      {(recharge?.data?.current_page - 1) *
                        recharge?.data?.per_page +
                        index +
                        1}
                    </td>
                    <td>{val?.price}</td>
                    <td>
                      {val?.Vehicle_Category?.name}(
                      {val?.Vehicle_Category?.type || "-"})
                    </td>
                    <td>{val?.City?.name}</td>
                    <td>{`${val?.discount_percent}%` || "-"}</td>
                    <td>{`${val?.tax_percent}%` || "-"}</td>
                    <td>
                      {" "}
                      {val?.Vehicle_Category?.type === "Share" ? "" : "₹"}{" "}
                      {val?.expiry_day || "-"}
                    </td>
                    <td>{val?.description || "-"}</td>

                    {Permission.includes(IDS.Permission.Recharge.Edit) && (
                      <>
                        <td>
                          <Form.Check
                            type="switch"
                            id={`custom-switch-${val?.id}`}
                            checked={val?.status}
                            onChange={() => handleStatusModal(val?.id)}
                            label={val?.status ? IDS.ACTIVE : IDS.INACTIVE}
                          />
                        </td>
                      </>
                    )}

                    <td>
                      <div className="action_btns">
                        {Permission.includes(IDS.Permission.Recharge.Edit) && (
                          <button
                            type="button"
                            className="editbtn"
                            onClick={() => {
                              setId(val?.id);

                              setTimeout(() => {
                                const element = document.querySelector(
                                  ".content_body",
                                );

                                if (element) {
                                  element.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                  });
                                } else {
                                  window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                  });
                                }
                              }, 100);
                            }}
                          >
                            <Link>
                              <img
                                className="icon"
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/icons/edit.png"
                                }
                              />
                            </Link>
                          </button>
                        )}

                        {Permission.includes(
                          IDS.Permission.Recharge.Delete,
                        ) && (
                          <button
                            type="button"
                            className="editbtn"
                            onClick={() => handleDeleteModal(val?.id)}
                          >
                            <Link>
                              <img
                                className="icon"
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/icons/delete.png"
                                }
                              />
                            </Link>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Delete_Modal
        message={"Successful"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <Delete_Confirm_Modal
        handleDelete={handleDelete}
        show={deleteConfirmModal}
        onHide={() => setDeleteConfirmModal(false)}
      />
      <Confirm_Status_Change
        handleStatusChange={handleStatusChange}
        show={statusConfirmModal}
        onHide={() => setStatusConfirmModal(false)}
      />
      <Pagination_Holder
        onPageChange={recharge?.data?.current_page}
        totalPages={recharge?.data?.total_pages}
        handlePageChange={handlePageChange}
      />
    </section>
  );
};

export default Country;
